export const appVersion: string = "1.11.22";